module.exports = __webpack_public_path__ + "static/media/avatar-1.d8810db2.jpg";